import request from '@/utils/request';

//场景营销列表
export function getSceneMarketingList(values) {
  return request('/activity/queryScenePage', {
    method: 'POST',
    data: values,
  });
}
// 查询活动详情
export function getSceneMarketingDetail(values) {
  return request('/activity/querySceneDetail', {
    method: 'POST',
    data: values,
  });
}
// 创建活动详情
export function handleAddSceneMarketing(values) {
  return request('/activity/scene/add', {
    method: 'POST',
    data: values,
  });
}
// 暂停/终止活动
export function handleSuspendSceneMarketing(values) {
  return request('/activity/scene/changeStatus', {
    method: 'POST',
    data: values,
  });
}
// 是否可以点击校验

export function getCheckIsCreated(values) {
  return request('/activity/scene/checkIsCreated', {
    method: 'GET',
    params: values,
  });
}
// 更新活动详情
export function handleUpdateSceneMarketing(values) {
  return request('/activity/scene/update', {
    method: 'POST',
    data: values,
  });
}
//会员等级
export function getMemberLevel() {
  return request('/config/queryLevels', {
    method: 'GET',
    // params: values,
  });
}
// 获取公司列表
export function getCompanyList(values) {
  return request('/company/queryList', {
    method: 'GET',
    params: values,
  });
}
// 获取微信模板信息
export function getWechatTemplateList(values) {
  return request('/message/queryWechatTemplateList', {
    method: 'POST',
    data: values,
  });
}
// 获取短信模板消息
export function getSmsTemplateList() {
  return request('/sms/queryTemplateList', {
    method: 'GET',
    // params: values,
  });
}
// 校验场景营销活动是否可以创建
export function getIsCreated() {
  return request('/activity/scene/checkIsCreated', {
    method: 'GET',
    // params: values,
  });
}
// 场景营销审批
export function ApproveSceneMarketing(values) {
  return request('/activity/scene/approve', {
    method: 'POST',
    data: values,
  });
}
// 场景营销重启
export function RestartSceneMarketing(values) {
  return request('/activity/scene/restart', {
    method: 'POST',
    data: values,
  });
}
// 弹窗
//会员层级mock
export function apiChart1(id) {
  return request(`/members/${id}/dashboard/summary`, {
    method: 'GET',
    // params: values,
  });
}
export function apiChart2(id) {
  return request(`/members/${id}/dashboard/point`, {
    method: 'GET',
    // params: values,
  });
}
export function apiChart3(id) {
  return request(`/members/${id}/dashboard/point-channel`, {
    method: 'GET',
  });
}
export function apiChart4(id) {
  return request(`/members/${id}/dashboard/consumption-channel`, {
    method: 'GET',
  });
}
export function apiChart5(id) {
  return request(`/members/${id}/dashboard/journey`, {
    method: 'GET',
  });
}
export function apiChart6(id) {
  return request(`/members/${id}/dashboard/consumption`, {
    method: 'GET',
  });
}
